import { render, staticRenderFns } from "./StatsLostSources.vue?vue&type=template&id=ec247de4"
import script from "./StatsLostSources.vue?vue&type=script&lang=js"
export * from "./StatsLostSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports